module.exports = __webpack_public_path__ + "static/media/Milan_WelcomeKit_ENG_digital_111119.d8aa4940.pdf";